module.exports = __webpack_public_path__ + "static/img/main4.75f6f2d5.png";